import script from "./PropertyCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropertyCard.vue?vue&type=script&setup=true&lang=ts"

import "./PropertyCard.vue?vue&type=style&index=0&id=3368767a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3368767a"]])

export default __exports__